import { Drawer, DrawerProps as MuiDrawerProps, styled } from "@mui/material";

const StyledDrawer = styled(Drawer)(({ theme }) => {
  return {
    color: theme.palette.toggleButton.background,
    "& .MuiDrawer-paper": {
      backgroundColor: theme.palette.background.paper,
    },
  };
});

interface ActivityLogDrawerProps extends MuiDrawerProps {}

export const ActivityLogDrawer: React.FC<ActivityLogDrawerProps> = ({ ...props }) => {
  return <StyledDrawer {...props} />;
};

export default ActivityLogDrawer;
